import React, { useState } from "react";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import api from "../../lib/api";
import PostCard from "../beta/PostCard";

// v218: søk i veggposter via hashtags (#norge eller norge). Kun offentlige poster.
export default function PostSearchPanel() {
  const { t } = useTranslation();
  const [q, setQ] = useState("");
  const [tag, setTag] = useState("");
  const [items, setItems] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [busy, setBusy] = useState(false);
  const [searched, setSearched] = useState(false);

  const run = async (reset) => {
    const tg = reset ? q.trim().replace(/^#+/, "").toLowerCase() : tag;
    if (tg.length < 2 || busy) return;
    setBusy(true);
    try {
      const params = { limit: 20 };
      if (!reset && cursor) params.cursor = cursor;
      const r = await api.get(`/tags/${encodeURIComponent(tg)}/posts`, { params });
      const n = r.data?.items || [];
      setItems((prev) => (reset ? n : [...prev, ...n]));
      setCursor(r.data?.next_cursor || null);
      setTag(tg);
      setSearched(true);
    } catch { /* stille */ }
    setBusy(false);
  };

  return (
    <div className="max-w-2xl" data-testid="post-search-panel">
      <form onSubmit={(e) => { e.preventDefault(); run(true); }} className="flex gap-2 mb-6">
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={t("search_page.posts_placeholder")}
          className="flex-1 bg-transparent border border-white/15 rounded-sm px-3 py-2 text-sm text-[var(--cream)] focus:border-[var(--magenta)] outline-none"
          data-testid="post-search-input"
        />
        <button type="submit" disabled={busy || q.trim().replace(/^#+/, "").length < 2} className="btn-magenta" data-testid="post-search-btn">
          <Search className="h-3.5 w-3.5 inline mr-2" /> {busy ? "…" : t("search_page.search_btn")}
        </button>
      </form>

      {searched && items.length === 0 && !busy && (
        <p className="text-sm text-[var(--cream-soft)]" data-testid="post-search-empty">{t("search_page.posts_empty", { tag })}</p>
      )}
      {items.map((p) => <PostCard key={p.id} post={p} />)}
      {cursor && (
        <button onClick={() => run(false)} disabled={busy} className="btn-ghost w-full mt-2" data-testid="post-search-more">
          {busy ? "…" : t("search_page.posts_more")}
        </button>
      )}
    </div>
  );
}
